import React from 'react'

import './BackDrop.css'

export const BackDrop = props => {
    return (
        <div className="backdrop" onClick={props.click}/>
    )
}
